import React from "react";
import { ContactoComponent } from "../components";
import { useDispatch, useSelector } from "react-redux";
import { sendMessage, resetStatus } from "../redux/enviarMail";

function ContactoContainer({ itemsArray }) {
  const dispatch = useDispatch();
  const sendStatus = useSelector(store => store.send)
  const sendMessege = async (data) => {
    try {
      await dispatch(sendMessage(data));
      setTimeout(()=>{dispatch(resetStatus())} , "1500")
    } catch (err) {
      console.log(err);
      setTimeout(()=>{dispatch(resetStatus())} , "1500")
    }
  };
  return <ContactoComponent items={{ fn: sendMessege, status: sendStatus}} />;
}

export default ContactoContainer;
